import actions from "./actions";

export default {
  namespaced: true,
  state: {
    dataLoading: false,
    auOwners: null
  },
  getters: {
    dataLoading: state => {
      return state.dataLoading;
    },
    auOwners: state => {
      return state.auOwners;
    }
  },
  mutations: {
    setDataLoading(state, dataLoading) {
      state.dataLoading = dataLoading;
    },
    setAuOwners(state, owners) {
      state.auOwners = owners;
    }
  },
  actions
};